import BossModel from "@/models/BossModel";
import User from "@/models/User/User";

export default class Receiver extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/notification/receiver';

    /**
     *
     * @type {string}
     */
    static entity = 'userNotificationsReceivers';

    static fields() {
        return {
            id: this.number(null).nullable(),
            user_notification_id: this.number(null).nullable(),
            is_send: this.boolean(0),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            user_id: this.number(null).nullable(),
            user: this.belongsTo(User, 'user_id'),
        }
    }
}
